import React from "react";
import {
  entityRowDeleteActionClassName,
  entityRowTonalActionClassName,
} from "../../design/tokens.js";
import AppButton from "./AppButton.jsx";

/**
 * Datei-Zeilen-Aktionen — maximal zwei sichtbare Aktionen:
 * «Vorschau» (Modal inkl. Download) oder «Download», plus optional «Löschen».
 */
export default function FileActions({
  url,
  fileName,
  canPreview = false,
  canDelete = false,
  onDelete = null,
  showPreview = false,
  onPreview = null,
  compact = false,
  disabled = false,
  loading = false,
  previewDisabled = false,
  downloadDisabled = false,
  deleteDisabled = false,
  mode = "full",
}) {
  const actionLocked = Boolean(disabled || loading);
  const disabledCls = actionLocked ? "opacity-60 pointer-events-none" : "";
  const labelName = String(fileName || "Datei");
  const compactSizeCls = compact ? "!h-8 !min-h-8 !max-h-8" : "";
  const previewShellCls = `${entityRowTonalActionClassName} ${compactSizeCls}`.trim();
  const deleteShellCls = `${entityRowDeleteActionClassName} ${compactSizeCls}`.trim();

  const hasPreviewAction = Boolean(
    showPreview && typeof onPreview === "function",
  );
  const showDownload = Boolean(url) && !hasPreviewAction;

  if (!url && !canDelete) return null;

  return (
    <div className="flex shrink-0 flex-row flex-wrap items-center justify-end gap-2">
      {!url ? (
        <span className="text-xs text-red-200/80">Datei-URL fehlt</span>
      ) : null}

      {hasPreviewAction ? (
        <AppButton
          type="button"
          variant="secondary"
          size="sm"
          onClick={actionLocked || previewDisabled ? undefined : onPreview}
          className={`${previewShellCls} ${disabledCls}`}
          disabled={actionLocked || previewDisabled}
          aria-label={`Vorschau: ${labelName}`}
        >
          Vorschau
        </AppButton>
      ) : null}

      {showDownload ? (
        <a
          href={actionLocked || downloadDisabled ? undefined : url}
          download={fileName || "datei"}
          className={`inline-flex items-center text-xs font-medium text-blue-200 hover:text-white no-underline ${previewShellCls} ${disabledCls}`}
          aria-disabled={actionLocked || downloadDisabled}
          aria-label={`Datei herunterladen: ${labelName}`}
        >
          Download
        </a>
      ) : null}

      {canDelete && typeof onDelete === "function" ? (
        <AppButton
          type="button"
          variant="secondary"
          size="sm"
          onClick={actionLocked || deleteDisabled ? undefined : onDelete}
          className={`${deleteShellCls} ${disabledCls}`}
          disabled={actionLocked || deleteDisabled}
          aria-label={`Datei löschen: ${labelName}`}
        >
          {loading ? "Lädt…" : "Löschen"}
        </AppButton>
      ) : null}
    </div>
  );
}
